import { ButtonPrimary, IconSpeechBubble } from 'mage-deps/@klarna/bubble-ui'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { hooks } from 'mage-i18n'
import { useHelpContext } from './hooks'
import { useResponsiveContext } from 'mage-deps/@klarna/mp-ui'

export default function ChatButton({ container }) {
  const [isChatButtonVisible, setChatButtonVisible] = useState(true)
  const buttonContainerHeight = 120

  const t = hooks.useTranslator()
  const { isMobile, isTablet } = useResponsiveContext()

  const {
    sidebar: { isOpen },
    setIsOpen
  } = useHelpContext()

  function handleChatButton() {
    if (isOpen) {
      setIsOpen(false)
    }

    window.fcWidget.on('widget:closed', function() {
      setIsOpen(true)
    })

    window.fcWidget.open()
  }

  useEffect(() => {
    if (container) {
      container.addEventListener('scroll', hideChatButtonOnScroll)

      return () => container.removeEventListener('scroll', hideChatButtonOnScroll)
    }

    function hideChatButtonOnScroll() {
      const currentScrollPosition = container.scrollTop
      if (currentScrollPosition <= 10) {
        setChatButtonVisible(true)
      } else {
        setChatButtonVisible(false)
      }
    }
  }, [container])

  return (
    <div
      style={{
        position: isMobile || isTablet ? 'fixed' : 'absolute',
        bottom: isChatButtonVisible ? 0 : -buttonContainerHeight,
        transition: 'bottom .2s ease-in-out',
        width: '100%',
        height: buttonContainerHeight,
        background: 'linear-gradient(0, rgba(255,255,255,1) 60%, rgba(255,255,255,0) 100%)',
        padding: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end'
      }}
    >
      <ButtonPrimary
        data-browser-test-id="uhqm-chat-button"
        icon={IconSpeechBubble}
        size="medium"
        onClick={handleChatButton}
      >
        {t('conversation.widget.title')}
      </ButtonPrimary>
    </div>
  )
}

ChatButton.propTypes = {
  container: PropTypes.instanceOf(Element)
}
